import { getData, postData } from '../../../utils/fetch-api-util';
import { API_URLS } from '../../../constants/urls/api-urls';
import { CATEGORY, HomeGroupKey, HomeType, HomeTypeExplorer, HomeWidgetStatus } from '../../../types/home';
import { Align } from '../../../types/common';
import { HomeWidgetGroupKey } from '../../../constants/home';

interface HomeWidgetsRequest {
  //
}

export interface HomeWidgetsRecord {
  index?: number;
  id: string;
  groupKey?: HomeGroupKey;
  name?: string;
  type?: HomeType | HomeTypeExplorer;
  heading?: string;
  title?: string;
  description?: string;
  backgroundColor?: string;
  backgroundImage?: string;
  contentType?: string;
  contentId?: any;
  productId?: string;
  contentFormat?: string;
  ctaText?: string;
  ctaLink?: string;
  extraData?: any;
  sortOrder: number;
  status?: HomeWidgetStatus;
  show?: boolean;
  category?: CATEGORY;
  textColor?: string;
  colorOpacity?: number;
  buttonAlign?: Align;
  textAlign?: Align;
  countries?: string;
}

export interface HomeWidgetPayload {
  groupKey?: HomeGroupKey;
  name?: string;
  type?: string;
  heading?: string;
  title?: string | null;
  description?: string | null;
  backgroundColor?: string | null;
  backgroundImage?: string | null;
  contentType?: string | null;
  contentId?: any | null;
  productId?: string | null;
  contentFormat?: string | null;
  ctaText?: string | null;
  ctaLink?: string | null;
  extraData?: any;
  sortOrder?: number;
  status?: HomeWidgetStatus;
  show?: boolean;
  category?: string | null;
  textColor?: string | null;
  colorOpacity?: number | null;
  buttonAlign?: Align | string | null;
  textAlign?: Align | string | null;
  countries?: any;
}

interface SortHomeWidgetsPayload {
  sortOrderList: {
    id: string;
    sortOrder: number;
    name?: string;
    status?: HomeWidgetStatus;
  }[];
  groupKey?: HomeWidgetGroupKey;
}

interface DeleteHomeWidgetPayload {
  id: string;
}

interface SuccessResponse {
  success: boolean;
}

export const getHomeWidgetsRepository = async (request?: any): Promise<HomeWidgetsRecord[]> => {
  const response = await getData<HomeWidgetsRequest, HomeWidgetsRecord[]>(API_URLS.HOME_WIDGETS, request);
  return response.data;
};

export const postCreateHomeWidgetsRepository = async (payload: HomeWidgetPayload): Promise<HomeWidgetsRecord> => {
  const response = await postData<HomeWidgetPayload, HomeWidgetsRecord>(API_URLS.CREATE_HOME_WIDGETS, payload);
  return response.data;
};

export const postUpdateHomeWidgetsRepository = async (
  id: string,
  payload: HomeWidgetPayload,
): Promise<HomeWidgetsRecord> => {
  const response = await postData<HomeWidgetPayload, HomeWidgetsRecord>(
    `${API_URLS.UPDATE_HOME_WIDGETS}/${id}`,
    payload,
  );
  return response.data;
};

export const postSortHomeWidgetsRepository = async (payload: SortHomeWidgetsPayload): Promise<void> => {
  await postData<SortHomeWidgetsPayload, SuccessResponse>(API_URLS.SORT_HOME_WIDGETS, payload);
};

export const postDeleteHomeWidgetsRepository = async (payload: DeleteHomeWidgetPayload): Promise<void> => {
  await postData<DeleteHomeWidgetPayload, SuccessResponse>(API_URLS.DELETE_HOME_WIDGETS, payload);
};
